import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useQuery } from "@tanstack/react-query";
import { callPymbleApi } from "./usePymbleApi";

export const NO_TRANSPORT_CODE = "none";

const EVENT_TRANSPORT_ENDPOINT = "dictionary/EventTransport";

export type TransportOption = {
	id: string;
	label: string;
	description?: string;
	imageUrl?: string;
};

/**
 * Hook to fetch the transport options from the S2 dictionary
 * collection (`EventTransport`).
 */
export function useEventTransport() {
	const { instance } = useMsal();
	const isAuthenticated = useIsAuthenticated();

	const { data: options = [], isPending } = useQuery({
		queryKey: ["eventTransport"],
		queryFn: async () => {
			const res = await callPymbleApi(
				instance,
				"GET",
				EVENT_TRANSPORT_ENDPOINT
			);
			if (!res) return [];
			const list: (TransportOption & { order: number })[] = [];
			// Entries may arrive flat or wrapped as documents with a Data array.
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			const entries: any[] = (Array.isArray(res) ? res : []).flatMap(
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				(e: any) => (Array.isArray(e["Data"]) ? e["Data"] : [e])
			);
			for (const item of entries) {
				if (item["Active"] === false || !item["Code"]) continue;
				list.push({
					id: String(item["Code"]),
					label: item["Name"],
					description: item["Description"],
					imageUrl: item["ImageUrl"],
					order: item["Order"] ?? 0,
				});
			}
			list.sort((x, y) => x.order - y.order);
			return list;
		},
		enabled: isAuthenticated,
	});

	return { options, isLoading: isPending };
}
